import * as React from "react";
export const RecentActivities = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={600.7} height={424.2} viewBox="0 0 600.7 424.2" {...props}>
      <defs>
        <linearGradient
          id="a"
          x1={0.515}
          y1={2.629}
          x2={0.388}
          y2={4.092}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#a1c3fc" />
          <stop offset={0.696} stopColor="#81aef2" />
          <stop offset={1} stopColor="#78a9ef" />
        </linearGradient>
        <linearGradient
          id="b"
          x1={0.746}
          y1={3.834}
          x2={-0.168}
          y2={4.761}
          xlinkHref="#a"
        />
        <linearGradient
          id="c"
          x1={0.293}
          y1={2.194}
          x2={1.053}
          y2={3.243}
          xlinkHref="#a"
        />
        <linearGradient
          id="d"
          x1={0.433}
          y1={14.216}
          x2={0.521}
          y2={16.493}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0.09} stopColor="#eee" />
          <stop offset={0.818} stopColor="#d6d7d8" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={0.749}
          y1={-19.226}
          x2={-0.141}
          y2={-20.489}
          xlinkHref="#d"
        />
        <linearGradient
          id="f"
          x1={0.511}
          y1={3.003}
          x2={0.491}
          y2={1.47}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0.129} stopColor="#428dfc" />
          <stop offset={0.999} stopColor="#1d72d8" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={0.554}
          y1={3.574}
          x2={0.45}
          y2={1.993}
          xlinkHref="#f"
        />
        <linearGradient
          id="h"
          x1={1.064}
          y1={-4.836}
          x2={0.52}
          y2={-5.151}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0.14} stopColor="#e94a47" />
          <stop offset={1} stopColor="#c63030" />
        </linearGradient>
        <linearGradient
          id="i"
          x1={0.472}
          y1={-23.11}
          x2={0.523}
          y2={-19.779}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#23286b" />
          <stop offset={1} stopColor="#151a4f" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={-2.927}
          y1={-7.703}
          x2={1.178}
          y2={-8.969}
          xlinkHref="#i"
        />
        <linearGradient
          id="k"
          x1={0.517}
          y1={-3.444}
          x2={0.405}
          y2={-4.425}
          xlinkHref="#i"
        />
        <linearGradient
          id="l"
          x1={0.568}
          y1={-27.745}
          x2={-0.052}
          y2={-26.987}
          xlinkHref="#i"
        />
        <linearGradient
          id="m"
          x1={-0.071}
          y1={-25.794}
          x2={0.426}
          y2={-27.666}
          xlinkHref="#i"
        />
        <linearGradient
          id="n"
          x1={0.808}
          y1={-19.33}
          x2={-0.748}
          y2={-20.581}
          xlinkHref="#d"
        />
        <linearGradient
          id="o"
          x1={0.905}
          y1={-19.146}
          x2={-0.29}
          y2={-20.42}
          xlinkHref="#d"
        />
        <linearGradient
          id="p"
          x1={-0.44}
          y1={-10.934}
          x2={0.396}
          y2={-11.75}
          xlinkHref="#f"
        />
        <linearGradient
          id="q"
          x1={-0.5}
          y1={-0.675}
          x2={0.927}
          y2={-0.57}
          xlinkHref="#i"
        />
        <linearGradient
          id="r"
          x1={0.827}
          y1={-19.121}
          x2={-0.12}
          y2={-20.452}
          xlinkHref="#d"
        />
        <linearGradient
          id="s"
          x1={0.004}
          y1={6.971}
          x2={0.996}
          y2={6.971}
          xlinkHref="#i"
        />
        <linearGradient
          id="t"
          x1={0.003}
          y1={21.22}
          x2={0.995}
          y2={21.22}
          xlinkHref="#i"
        />
        <linearGradient
          id="u"
          x1={0}
          y1={-0.15}
          x2={1}
          y2={-0.15}
          xlinkHref="#d"
        />
        <linearGradient
          id="v"
          x1={0}
          y1={-0.801}
          x2={1}
          y2={-0.801}
          xlinkHref="#i"
        />
        <linearGradient
          id="w"
          x1={0.439}
          y1={-0.743}
          x2={0.12}
          y2={-0.434}
          xlinkHref="#i"
        />
        <linearGradient
          id="x"
          x1={0.72}
          y1={2.589}
          x2={0.08}
          y2={0.347}
          xlinkHref="#i"
        />
        <linearGradient
          id="y"
          x1={0.373}
          y1={2.568}
          x2={1.115}
          y2={0.732}
          xlinkHref="#i"
        />
        <linearGradient
          id="z"
          x1={-0.015}
          y1={2.614}
          x2={1.091}
          y2={1.392}
          xlinkHref="#i"
        />
        <linearGradient
          id="aa"
          x1={-0.001}
          y1={2.379}
          x2={1}
          y2={2.379}
          xlinkHref="#i"
        />
        <linearGradient
          id="ab"
          x1={0.698}
          y1={-0.737}
          x2={-0.35}
          y2={-0.198}
          xlinkHref="#i"
        />
        <linearGradient
          id="ac"
          x1={0}
          y1={0.948}
          x2={1}
          y2={0.948}
          xlinkHref="#a"
        />
        <linearGradient
          id="ad"
          x1={0.107}
          y1={5.423}
          x2={0.723}
          y2={3.959}
          xlinkHref="#h"
        />
        <linearGradient
          id="ae"
          x1={0.543}
          y1={6.101}
          x2={0.378}
          y2={4.467}
          xlinkHref="#h"
        />
        <linearGradient
          id="af"
          x1={0.786}
          y1={2.424}
          x2={-0.181}
          y2={3.613}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ffbeb6" />
          <stop offset={1} stopColor="#f2a19c" />
        </linearGradient>
        <linearGradient
          id="ag"
          x1={0.165}
          y1={8.237}
          x2={0.885}
          y2={9.607}
          xlinkHref="#af"
        />
        <linearGradient
          id="ah"
          x1={0.599}
          y1={0.713}
          x2={-0.017}
          y2={1.205}
          xlinkHref="#a"
        />
        <linearGradient
          id="ai"
          x1={0.701}
          y1={0.618}
          x2={0.039}
          y2={-0.485}
          xlinkHref="#h"
        />
      </defs>
      <g transform="translate(-130.1 -96)">
        <rect
          width={8.9}
          height={20.5}
          transform="translate(681.4 266.7)"
          fill="url(#a)"
        />
        <path d="M710,178.8l-5.7,7.4L595.8,96h14.3Z" fill="url(#b)" />
        <path d="M690.3,262.8h-8.9l22-78h8.9Z" fill="url(#c)" />
        <path d="M559,96v.2a25.55,25.55,0,0,0,51.1,0V96Z" fill="url(#d)" />
        <path d="M646,296.7H489.6l-.1-4.8H645.9Z" fill="#23286b" />
        <circle
          cx={10.4}
          cy={10.4}
          r={10.4}
          transform="translate(351.3 499.4)"
          fill="url(#e)"
        />
        <rect
          width={32.7}
          height={30.3}
          transform="translate(390.9 262.1)"
          fill="url(#f)"
        />
        <rect
          width={80.8}
          height={4.8}
          transform="translate(368.2 292)"
          fill="#428dfc"
        />
        <rect
          width={26.9}
          height={13.5}
          transform="translate(221.6 279)"
          fill="url(#g)"
        />
        <rect
          width={63.5}
          height={4.3}
          transform="translate(203.8 292.5)"
          fill="#428dfc"
        />
        <rect
          width={136.9}
          height={25.3}
          transform="translate(265.5 360)"
          fill="url(#h)"
        />
        <path
          d="M309,385.3h49.7a7.917,7.917,0,0,1-7.9,7.9H317a7.876,7.876,0,0,1-8-7.9Z"
          fill="url(#i)"
        />
        <rect
          width={12.2}
          height={22.3}
          transform="translate(327.7 393.1)"
          fill="url(#j)"
        />
        <path
          d="M332.5,413h2.7a8.024,8.024,0,0,1,8,8v65.2H324.5V421A7.9,7.9,0,0,1,332.5,413Z"
          fill="url(#k)"
        />
        <path
          d="M333.9,486.2h46a10.179,10.179,0,0,1,10.2,10.2v3.3h-3.3v-2.1a8.066,8.066,0,0,0-8.1-8.1H333.9Z"
          fill="url(#l)"
        />
        <path
          d="M333.9,486.2h19.4a10.179,10.179,0,0,1,10.2,10.2v3.3h-3.3v-2.1a8.066,8.066,0,0,0-8.1-8.1H333.9Z"
          fill="#23286b"
        />
        <path
          d="M334.1,486.2h-46a10.179,10.179,0,0,0-10.2,10.2v3.3h3.3v-2.1a8.066,8.066,0,0,1,8.1-8.1h44.8Z"
          fill="url(#m)"
        />
        <path
          d="M334.1,486.2H314.7a10.179,10.179,0,0,0-10.2,10.2v3.3h3.3v-2.1a8.066,8.066,0,0,1,8.1-8.1h18.2Z"
          fill="#23286b"
        />
        <circle
          cx={10.4}
          cy={10.4}
          r={10.4}
          transform="translate(295.7 499.4)"
          fill="url(#n)"
        />
        <circle
          cx={10.4}
          cy={10.4}
          r={10.4}
          transform="translate(378.1 499.4)"
          fill="url(#o)"
        />
        <path
          d="M373.3,486.6l-12,33.5h84.8s-4.4-8.4-18.9-14.6-28-18.9-28-18.9H373.3"
          fill="url(#p)"
        />
        <path
          d="M313.2,332.4s11.1,25.6,44.4,29.1,19.8,37.4,16.9,42.7-6.5,9.9-8.6,18.1.9,18.8-2.4,24.8-17.2,26.2-12.9,39.5h48.7S427.4,376,425.5,365.1s1.2-19.7-28.1-33.3-49-22.1-49-22.1Z"
          fill="url(#q)"
        />
        <circle
          cx={10.4}
          cy={10.4}
          r={10.4}
          transform="translate(269.1 499.4)"
          fill="url(#r)"
        />
        <circle
          cx={5.7}
          cy={5.7}
          r={5.7}
          transform="translate(680.3 258.4)"
          fill="url(#s)"
        />
        <circle
          cx={5.7}
          cy={5.7}
          r={5.7}
          transform="translate(702.1 177.2)"
          fill="url(#t)"
        />
        <rect
          width={600.7}
          height={24.5}
          transform="translate(130.1 296.7)"
          fill="url(#u)"
        />
        <rect
          width={577.8}
          height={7.8}
          transform="translate(138.5 321.1)"
          fill="#23286b"
        />
        <path d="M182.3,329,148,514.7H138L172.4,329Z" fill="url(#v)" />
        <path d="M716.9,514.7h-10L672.6,329h9.9Z" fill="url(#w)" />
        <path d="M645.9,291.9H541l16.4-57.8H662.6Z" fill="url(#x)" />
        <rect
          width={235.9}
          height={102.5}
          transform="translate(289.2 159.9)"
          fill="url(#y)"
        />
        <rect
          width={147}
          height={77.5}
          transform="translate(162 202.4)"
          fill="url(#z)"
        />
        <path
          d="M660.3,287.2h39.2a9.6,9.6,0,0,1,9.6,9.6H650.8a9.518,9.518,0,0,1,9.5-9.6Z"
          fill="url(#aa)"
        />
        <rect
          width={73.4}
          height={2.8}
          transform="translate(173.8 212.8)"
          fill="#fff"
        />
        <rect
          width={73.4}
          height={2.8}
          transform="translate(173.8 219.4)"
          fill="#fff"
        />
        <rect
          width={73.4}
          height={2.8}
          transform="translate(173.8 226)"
          fill="#fff"
        />
        <rect
          width={73.4}
          height={2.8}
          transform="translate(173.8 232.6)"
          fill="#fff"
        />
        <path d="M629.3,245.4l-67.5-.2.8-2.5,67.5.2Z" fill="#fff" />
        <path d="M627.7,251.1l-67.5-.1.7-2.5,67.5.1Z" fill="#fff" />
        <path d="M626,256.8l-67.5-.1.7-2.5,67.5.2Z" fill="#fff" />
        <path d="M624.3,262.7l-67.5-.2.7-2.5,67.5.2Z" fill="#fff" />
        <path
          d="M373.8,213.6,387.4,199l-3.6-3.3L367.6,213h0l-.8.8.9.8,17.4,16.1,3.3-3.6Z"
          fill="#fff"
        />
        <path
          d="M434.6,213.6,421,199l3.6-3.3,16.1,17.4h0l.8.8-.9.8-17.4,16.1-3.3-3.6Z"
          fill="#fff"
        />
        <path d="M409,189.4l-14.1,46.4,4.5,1.3,14.1-46.4Z" fill="#fff" />
        <path
          d="M404.3,486.6l-12,33.5h84.8s-4.4-8.4-18.9-14.6-28-18.9-28-18.9H404.3"
          fill="#428dfc"
        />
        <path
          d="M322.9,326.5s-3.1,28.7,35.3,34.9,40.1,10.9,40.4,20.7-2.6,15.6-6.2,25.7-3.7,24-1.8,32.1-6.5,18.2-10.4,27.7a40.621,40.621,0,0,0-2.6,19.2h52.6s14.1-94.9,15.1-108.9,5.5-28.3-12.7-37.7-57.2-26.6-57.2-26.6Z"
          fill="url(#ab)"
        />
        <path
          d="M352.3,331.8a.212.212,0,1,0,.3,0h0a.188.188,0,0,0-.3,0Zm-3.1,3.3a.212.212,0,1,0,.3,0c-.1-.1-.2,0-.3,0Zm17.4,7.5a.2.2,0,1,0,.2.2h0c0-.2-.1-.2-.2-.2Zm-4.6.1a.215.215,0,0,0-.2.2h0a.2.2,0,1,0,.2-.2Zm-4.5.2a.2.2,0,1,0,.2.2h0C357.7,342.9,357.6,342.9,357.5,342.9Zm-4.6.1a.215.215,0,0,0-.2.2h0a.2.2,0,1,0,.4,0h0A.215.215,0,0,0,352.9,343Zm6.8,17.5a.187.187,0,0,0,0,.3c.1.1.2.1.2,0h0a.187.187,0,0,0,0-.3C359.8,360.4,359.8,360.5,359.7,360.5Zm2.3-26.6c-.1,0-.1.2-.1.2l.2.1c.1,0,.1-.2.1-.2h0c0-.1-.1-.1-.2-.1Zm-4.2,1.9c-.1,0-.1.2-.1.2a.1.1,0,0,0,.1.1h.2c.1,0,.1-.1.1-.2-.1-.1-.2-.2-.3-.1Zm-4.1,1.9c-.1,0-.1.1-.1.2s.1.1.2.1h0c.1,0,.1-.1.1-.2s-.1-.2-.2-.1Zm-4.2,1.8c-.1,0-.1.2-.1.2,0,.1.1.1.2.1h0c.1,0,.1-.1.1-.2h0c0-.1-.1-.1-.2-.1Zm13.1,11.9c0,.1,0,.2.1.2s.2,0,.2-.1h0c0-.1,0-.2-.1-.2S362.6,351.3,362.6,351.4Zm-4.3-1.6c0,.1,0,.2.1.2s.2,0,.2-.1h0c0-.1,0-.2-.1-.2h0a.31.31,0,0,0-.2.1Zm-5-17.7c-.2.1-.2.3-.2.5h0c.1.1.2.2.3.2h.2l.1-.1a.454.454,0,0,0,0-.5c-.1-.2-.2-.2-.4-.1Zm33.9,20c-.1.2,0,.4.2.4.2.1.4,0,.4-.2h0c.1-.2,0-.4-.2-.4-.1-.1-.3,0-.4.2Zm-8.3-2.5a.3.3,0,0,0,.2.4h0c.2.1.4,0,.4-.2.1-.2,0-.4-.2-.4-.1-.1-.3,0-.4.2Zm-8.2-2.5a.764.764,0,0,0,.2.5c.2.1.4,0,.4-.2h0c.1-.2,0-.4-.2-.4h0c-.2-.2-.4-.1-.4.1Zm-8.3-2.5a.3.3,0,0,0,.2.4h0c.2.1.4,0,.4-.2.1-.2,0-.4-.2-.4-.1-.1-.3,0-.4.2Zm-8.2-2.5c-.1.2.1.4.3.4a.3.3,0,0,0,.4-.2c.1-.2,0-.4-.2-.4h0c-.3-.1-.5,0-.5.2Zm31-8.9c-.2,0-.4.2-.3.4s.2.4.4.3.4-.2.3-.4h0c-.1-.2-.2-.3-.4-.3Zm-8.6.8c-.2,0-.4.2-.3.4,0,.2.2.4.4.3.2,0,.4-.2.3-.4h0a.446.446,0,0,0-.4-.3Zm-8.6.9c-.2,0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3Zm-8.6.9c-.2,0-.3.2-.3.4s.2.3.4.3h0c.2,0,.3-.2.3-.4h0c0-.2-.2-.3-.4-.3Zm-8.6.8c-.2,0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4a.446.446,0,0,0-.4-.3ZM369,359.5a.454.454,0,0,0,0,.5h0a.446.446,0,0,0,.5,0c.1-.2.1-.4-.1-.5,0-.1-.3-.1-.4,0Zm-6.7-5.4a.446.446,0,0,0,0,.5.454.454,0,0,0,.5,0h0a.454.454,0,0,0,0-.5h0c-.1-.2-.3-.2-.5,0Zm-6.7-5.5c-.1.2-.1.4.1.5a.454.454,0,0,0,.5,0h0a.446.446,0,0,0,0-.5.637.637,0,0,0-.6,0Zm28.5-23.7c-.2,0-.3.2-.3.4s.2.3.4.3h0c.2,0,.3-.2.2-.4C384.5,324.9,384.3,324.8,384.1,324.9Zm-7.5,1.5c-.2,0-.3.2-.2.4,0,.2.2.3.4.2.2,0,.3-.2.2-.4h0c-.1-.2-.2-.3-.4-.2Zm-7.6,1.5c-.1,0-.1,0-.2.1h0a.367.367,0,0,0-.1.3c0,.2.2.3.4.3h0c.2,0,.3-.2.2-.4,0-.1-.1-.1-.1-.2s-.1-.2-.2-.1Zm-7.5,1.5c-.2,0-.3.2-.2.4,0,.2.2.3.4.3s.3-.2.3-.4h0c-.2-.3-.4-.4-.5-.3Zm16.1,27.4a.247.247,0,0,0,.1.4h0a.247.247,0,0,0,.4-.1h0c.1-.2.1-.3-.1-.5a.4.4,0,0,0-.4.2Zm-6.4-4.3a.247.247,0,0,0,.1.4h0a.247.247,0,0,0,.4-.1h0a.247.247,0,0,0-.1-.4c-.1-.1-.3,0-.4.1Zm-6.4-4.3a.247.247,0,0,0,.1.4h0a.247.247,0,0,0,.4-.1h0a.247.247,0,0,0-.1-.4h0c-.1-.1-.3,0-.4.1Zm-6.4-4.3c-.1.1,0,.3.1.4a.292.292,0,1,0,.3-.5.6.6,0,0,0-.4.1Zm-6.4-4.2c-.1.2-.1.3.1.5a.292.292,0,0,0,.3-.5.208.208,0,0,0-.4,0Zm28.2.6c0,.2.1.3.3.4a.316.316,0,1,0,.2-.6c-.3-.1-.5,0-.5.2Zm-7.5-1.5c0,.2.1.3.3.4a.316.316,0,1,0,.2-.6h0c-.3-.1-.5,0-.5.2Zm-7.6-1.6a.52.52,0,0,0,.2.4h0c.2,0,.3-.1.4-.3a.52.52,0,0,0-.2-.4,1.38,1.38,0,0,0-.4.3Zm-7.5-1.5a.52.52,0,0,0,.2.4h.2a.215.215,0,0,0,.2-.2c0-.2-.1-.3-.3-.4-.1,0-.3.1-.3.2Zm-7.6-1.5v.2c.1,0,.1.1.1.2h.1a.52.52,0,0,0,.4-.2c0-.2-.1-.3-.3-.4-.1-.1-.3.1-.3.2Zm9.9,24.1a.44.44,0,0,0-.1.5c.1.1.3.2.4.1s.2-.3.1-.4c-.1-.3-.3-.3-.4-.2Zm6.2-20.4c0,.1,0,.2.1.2s.2,0,.2-.1,0-.2-.1-.2-.2,0-.2.1Zm-4.2-1.7c0,.1,0,.2.1.2h0c.1,0,.2,0,.2-.1h0a.367.367,0,0,0-.1-.3.215.215,0,0,0-.2.2Zm-4.2-1.8c0,.1,0,.2.1.2h0c.1,0,.2,0,.2-.1s0-.2-.1-.2-.2,0-.2.1Zm-4.2-1.7h0c0,.1,0,.2.1.2s.2,0,.2-.1h0c0-.1,0-.2-.1-.2h0c-.1-.1-.2,0-.2.1Zm12.2-4.6a.215.215,0,0,0-.2.2h0a.215.215,0,0,0,.2.2h0a.2.2,0,0,0,0-.4ZM359,344.2c-.1.1-.1.2,0,.2h0a.212.212,0,0,0,.3-.3A.367.367,0,0,0,359,344.2Zm-3.2-3.2c-.1.1-.1.2,0,.2h0a.187.187,0,0,0,.3,0h0a.187.187,0,0,0,0-.3.367.367,0,0,0-.3.1Zm-3.2-3.2a.212.212,0,1,0,.3,0,.187.187,0,0,0-.3,0Zm-3.1-3.3h-.1a.187.187,0,0,0,0,.3h.3a.187.187,0,0,0,0-.3h-.2Zm17.9,4.2c-.1.1,0,.2.1.3s.2,0,.3-.1a.187.187,0,0,0,0-.3h0c-.2,0-.3,0-.4.1Zm-4.3-2.8c-.1.1,0,.2.1.3s.2,0,.3-.1,0-.2-.1-.3h0c-.1,0-.3,0-.3.1Zm-4.4-2.8c-.1.1,0,.2.1.3s.2,0,.3-.1,0-.2,0-.3h0c-.2,0-.3,0-.4.1Zm10.4-5.3c-.1,0-.2,0-.3.2h0a.215.215,0,0,0,.2.2c.1,0,.2,0,.3-.2h0v-.1c0-.1-.1-.1-.2-.1Zm-10.9,16.7a.367.367,0,0,0-.1.3h0a.224.224,0,1,0,.4-.2h0a.192.192,0,0,0-.3-.1Zm-2.9-4.3a.224.224,0,1,0,.2.4h0a.367.367,0,0,0,.1-.3h0c-.1-.1-.2-.2-.3-.1Zm-2.9-4.3a.367.367,0,0,0-.1.3h0a.187.187,0,0,0,.3,0,.367.367,0,0,0,.1-.3Zm39.4-7.7c0,.2.1.4.3.4s.4-.1.4-.3-.1-.4-.3-.4c-.2-.1-.4.1-.4.3Zm-8.7-1.9c0,.2.1.4.3.4s.4-.1.4-.3-.1-.4-.3-.4S383.1,326.1,383.1,326.3Zm-8.7-1.8c0,.2.1.4.3.4s.4-.1.4-.3h0c0-.2-.1-.4-.3-.4S374.4,324.3,374.4,324.5Zm-3.6,34.3c-.2.1-.2.3-.1.5s.3.2.5.1.2-.3.1-.5a.44.44,0,0,0-.5-.1Zm-4.9-7.4c-.2.1-.2.3-.1.5s.3.2.5.1h0c.2-.1.2-.3.1-.5s-.3-.2-.5-.1Zm-4.8-7.5c-.2.1-.2.3-.1.5h0c.1.2.3.2.5.1s.2-.3.1-.5a.44.44,0,0,0-.5-.1Zm-4.9-7.4c-.2.1-.2.3-.1.5h0c.1.2.3.2.5.1s.2-.3.1-.5-.3-.2-.5-.1Zm25,6.2c-.1.2-.1.4.1.5h0c.2.1.4.1.5-.1s.1-.4-.1-.5a.348.348,0,0,0-.5.1Zm-7.3-5c-.1.2-.1.4.1.5h0c.2.1.4.1.5-.1h0c.1-.2.1-.4-.1-.5h0c-.2-.1-.4-.1-.5.1Zm-7.4-5c-.1.2-.1.4.1.5s.4.1.5-.1.1-.4-.1-.5h0c-.1-.1-.3-.1-.5.1Zm19.3,6c-.1.2-.1.4.1.5s.4.1.5-.1.1-.4-.1-.5a.348.348,0,0,0-.5.1Zm-7.5-4.7a.361.361,0,1,0,.6.4c.1-.2.1-.4-.1-.5s-.4-.1-.5.1Zm-7.5-4.7c-.1.2-.1.4.1.5s.4.1.5-.1.1-.4-.1-.5a.44.44,0,0,0-.5.1ZM351.7,343c-.2,0-.3.2-.3.4h0c0,.2.2.3.4.3s.3-.2.3-.4c0-.3-.2-.4-.4-.3Zm-2-8.7a.215.215,0,0,0-.2.2h0a.367.367,0,0,0-.1.3v.1a.365.365,0,0,0,.5.2c.2-.1.3-.3.2-.4h0c0-.1-.1-.1-.1-.2-.1-.2-.2-.2-.3-.2Zm20.6,14.3c-.2.1-.2.3-.1.5h0c.1.2.3.2.5.1s.2-.3.1-.5-.4-.3-.5-.1Zm-5.2-7.2c-.2.1-.2.3-.1.5h0c.1.2.3.2.5.1s.2-.3.1-.5-.3-.3-.5-.1Zm-5.1-7.2c-.2.1-.2.3-.1.5s.3.2.5.1.2-.3.1-.5-.4-.3-.5-.1Zm11.6-.9a.3.3,0,0,0,0,.4h0a.283.283,0,1,0,0-.4Zm-4.8-4.6a.3.3,0,0,0,0,.4h0a.283.283,0,1,0,0-.4Zm-8.2,9.7c-.1.1-.2.2-.2.3h0a.52.52,0,0,0,.4.2h0c.1-.1.2-.2.1-.4a.192.192,0,0,0-.3-.1Zm-2.7-6.1c-.1.1-.2.2-.1.4.1.1.2.2.4.1.1-.1.2-.2.1-.4-.1-.1-.3-.2-.4-.1Z"
          fill="#fff"
          opacity={0.86}
        />
        <path
          d="M317.9,225.2s-34.4,49.3-23,99.6c0,0,37.3,18.1,70.7-14.2,0,0-30.8-60.3-32.5-77.4h0l-15.2-8"
          fill="url(#ac)"
        />
        <path
          d="M406.4,238.5h21.1v15.4a10.605,10.605,0,0,1-10.6,10.6h0a10.605,10.605,0,0,1-10.6-10.6l.1-15.4Z"
          fill="url(#ad)"
        />
        <path
          d="M415.8,244.9h3.1a2.433,2.433,0,0,1,2.4,2.4h0v15.8h-7.8V247.3A2.286,2.286,0,0,1,415.8,244.9Z"
          fill="url(#ae)"
        />
        <path
          d="M403.9,267s6-11.6,9.5-13.8c0,0,0,8,3.6,7.9,4.2-.1,4.4-7.4,4.2-10.9-.1-2.5-.4-2.3,1.9-1.6,1.5.5,10.1,4.7,8.4,16.3s-18.8,11.7-21.1,13.1l-3,1.8L403.9,267"
          fill="url(#af)"
        />
        <path
          d="M333.2,233.2l-15.3-8,4.7-10.2a23.825,23.825,0,0,0,13.8,3.1C335.6,220.3,332.3,230.1,333.2,233.2Z"
          fill="url(#ag)"
        />
        <path
          d="M317.9,225.2s17,1.1,23.8,22.6,8.4,37.9,22.8,35.1,30.4-10.4,39.1-17.2l9.6,36.7s-8.8,13.2-21.6,14.4-22.4,8.8-29.9,12-24.7,8.4-33.1-3.6-22-50.3-20-83.9A136.885,136.885,0,0,1,317.9,225.2Z"
          fill="url(#ah)"
        />
        <path
          d="M357.6,385.3H265.5L242.3,261.5a16.943,16.943,0,0,1,13.6-19.8,16.279,16.279,0,0,1,3.1-.3h57.5a16.949,16.949,0,0,1,16.7,13.8Z"
          fill="url(#ai)"
        />
        <path
          d="M350.5,206.6s-2.3,9-11.6,11.1c-7.5,1.7-14-1.5-16.3-2.8.2-.3,3.7-6.2,0-8.6-3.8-2.5-3.8-3.8-3.9-5.6s2.6-4.3,7.1-2.8c4.5,1.6,9-2.3,9.3-7.7a28.454,28.454,0,0,0,13.6-.9c.6,1.4,3.9,10,5.3,12.4C355.6,204.3,351.8,206.4,350.5,206.6Z"
          fill="#ffbeb6"
        />
        <path
          d="M357.3,189.2a3.371,3.371,0,0,0-1.7-.5c-1.6,0-3.3,1.3-4.1,3.5-.1.3-.2.7-.3,1.1a2.958,2.958,0,0,0-1-.2,5.291,5.291,0,0,0-3,.9,1.268,1.268,0,0,0-.1-.6,6.334,6.334,0,0,0-1.5-3.2,2.7,2.7,0,0,0-.8-.7c-1.8-1.1-3.9-.6-5.4,1.2A8.841,8.841,0,0,0,338,193a10.111,10.111,0,0,0-.5,5.2,6.81,6.81,0,0,0,1.6,3.3,4.35,4.35,0,0,0,.7.6,3.7,3.7,0,0,0,3.8.1,6.462,6.462,0,0,0,2.9-3.6,9.092,9.092,0,0,0,.6-3.6,4.7,4.7,0,0,1,3.2-1c.1,0,.3.1.4.1v.4h0a1.268,1.268,0,0,0,.1.6c.7,1.7,1.4,3.4,2,4.7,2,1.3,4.6,0,5.8-3C360,194,359.3,190.5,357.3,189.2ZM346,198.1a6.321,6.321,0,0,1-2.6,3.2,2.891,2.891,0,0,1-3.1-.1,5.072,5.072,0,0,1-1.9-3.2,9.065,9.065,0,0,1,.4-4.6,6.356,6.356,0,0,1,1.9-2.7,3.154,3.154,0,0,1,3.9-.4l.1.1a1.756,1.756,0,0,1,.5.4,5.852,5.852,0,0,1,1.4,2.7,10.462,10.462,0,0,1-.6,4.6Zm12.2-1.6c-1,2.5-3.1,3.7-4.8,2.6s-2.2-4-1.2-6.5,3.1-3.7,4.8-2.6C358.6,191,359.2,194,358.2,196.5Z"
          fill="#fff"
        />
        <path
          d="M362.1,168.1a.365.365,0,0,0-.5-.2.536.536,0,0,0-.3.4c3.8,12.7-6.1,20.9-17.1,22.1,4.9-.7,10.6-2.9,14.3-9,7.4-12.3-3.4-17-9.6-13.7s-10.6,9.7-10.6,9.7-9.7-7.6-25.4-1.3-9.9,25.4-4.3,30.9,14,7.9,14,7.9,3.8-6.1,0-8.6-3.8-3.8-3.9-5.6,2.6-4.3,7.1-2.8c4.4,1.5,8.8-2.2,9.3-7.4h0c7.3,1.8,15.2,1.2,21.2-3.8A17.148,17.148,0,0,0,362.1,168.1Z"
          fill="#428dfc"
        />
      </g>
    </svg>
  );
};
